import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { GraduationCap, KeyRound, Loader2, UserPlus, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function InscriptionEleve() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [saving, setSaving] = useState(false);
  const [matricule, setMatricule] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!matricule.trim()) return toast.error("Saisissez votre matricule");
    setSaving(true);
    try {
      const { data } = await api.post("/student-portal/register-matricule", { matricule: matricule.trim() });
      localStorage.setItem("mazid_token", data.access_token);
      localStorage.setItem("mazid_user", JSON.stringify(data.user));
      localStorage.setItem("mazid_portal", "public");
      if (setUser) setUser(data.user);
      toast.success(`Bienvenue ${data.user.first_name} ! Votre compte a été créé.`);
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Échec de la création du compte");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-lg mx-auto px-4 py-12 sm:py-20">
        <div className="text-center mb-8">
          <div className="chip mb-3"><GraduationCap className="h-3 w-3" /><span>PORTAIL ÉLÈVE</span></div>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-[#1E3A8A] mb-3">Créez votre compte élève</h1>
          <p className="text-slate-600">Il vous suffit de votre <strong>matricule</strong>. Aucun email ni téléphone requis.</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-slate-200 space-y-5" data-testid="student-register-form">
          <div className="bg-yellow-50 border border-yellow-200 p-3 rounded-lg text-xs text-yellow-900">
            💡 <strong>Astuce :</strong> Votre matricule (ex : MZD-26-00001) vous a été communiqué par l&apos;administration. Si vous ne l&apos;avez pas, contactez le secrétariat.
          </div>

          <div>
            <Label className="flex items-center gap-1"><KeyRound className="h-3 w-3" /> Matricule *</Label>
            <Input
              value={matricule}
              onChange={(e) => setMatricule(e.target.value.toUpperCase())}
              placeholder="Ex : MZD-26-00001"
              className="font-mono text-lg h-12 tracking-wider"
              data-testid="matricule"
              required
            />
          </div>

          <div className="bg-blue-50 border border-blue-200 p-3 rounded-lg text-xs text-blue-900 flex gap-2">
            <ShieldCheck className="h-4 w-4 flex-shrink-0 mt-0.5" />
            <span>Votre <strong>mot de passe initial est votre matricule</strong>. Vous devrez le changer dès votre première connexion pour sécuriser votre compte.</span>
          </div>

          <Button type="submit" disabled={saving} className="w-full bg-[#1E3A8A] hover:bg-[#1E3A8A]/90 text-white h-12" data-testid="submit-register">
            {saving ? <Loader2 className="h-5 w-5 animate-spin mr-2" /> : <UserPlus className="h-5 w-5 mr-2" />}Créer mon compte
          </Button>

          <p className="text-xs text-slate-500 text-center pt-2">
            Déjà un compte ? <a href="/connexion" className="text-[#1E3A8A] font-semibold hover:underline">Connectez-vous avec votre matricule</a>
          </p>
        </form>
      </div>
    </div>
  );
}
